module.exports = __webpack_public_path__ + "img/p1-m.3f9a1c13.jpg";